<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row mb-2">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="voucher.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        <span class="text-lg" v-text="voucher.displayed_discount"></span> OFF
                    </div>
                </div>
                <div class="description">Minimum amount spent: {{ voucher.min_amount_spent }}</div>
                <div v-if="isBookingVoucher" class="description">Appliable for booking's total service cost</div>
                <div v-else class="description">Appliable for {{ voucher.product.name }} in {{ voucher.shop.name }}</div>
                <div v-if="voucher.shop" class="description">
                    Available only for bookings at 
                    <router-link :to="shopProfileLink" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="font-weight-700 link-hover-line">{{ voucher.shop.name }}</a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    name: "VocuherListItem",

    computed: {
        isBookingVoucher() {
            return this.voucher.product_type == "Booking";
        },
        displayImage() {
            return this.voucher.shop ? this.voucher.shop.display_image : "/images/placeholders/avatar.jpg";
        },
        displayedExpirationDate() {
            return this.voucher.expire_at
                ? moment(this.booking.expire_at).format("MMMM DD, YYYY hh:mm A")
                : "No expiration";
        },
        shopProfileLink() {
            return {name: 'Shop Page', params: { id: this.voucher.id }};
        },
    },
    
    props: {
        voucher: [Object],
    },

    mounted() {

    }
}
</script>